import { Layout } from 'antd';
import React from 'react';
import SubscriptionPlans from '../subscription/SubscriptionPlans';
import useGetSubscription from '../hooks/useGetSubscription';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';

const { Content } = Layout;

export default function SubscriptionPlansPage() {
    const { userSubscription, isInFreeTrial, isLoading } = useGetSubscription();

    return (
        <Content className="general-layout-content">
            {isLoading && <LoadingIndicator />}

            {!isLoading && (
                <SubscriptionPlans
                    userSubscription={userSubscription}
                    selectedPlanCode={userSubscription?.plan_details.code || ''}
                    isSubscriptionFreeTrial={isInFreeTrial}
                    includeHeader
                />
            )}
        </Content>
    );
}
